import React from 'react';
import './Gamify.css';
import './Header.css';
import { Link } from 'react-router-dom';



const games = [
  {
    icon: '/images/spin.svg',
    title: 'Spin N Win',
    bgClass: 'game-icon-green',
    description: `Add excitement to your campaigns with a chance for customers to Spin N Win discounts, airtime, data, and exclusive deals. Fully customizable to fit your brand, it’s a fun way to boost conversions and create memorable experiences.`
  },
  {
    icon: '/images/memory.svg',
    title: 'Memory Game',
    bgClass: 'game-icon-blue',
    description: `Boost engagement with a fun card-matching challenge. Customers compete for a grand prize, with a leaderboard to encourage friendly competition. Fully customizable, showcase your products and services for a memorable brand experience.`
  },
  {
    icon: '/images/puzzle.svg',
    title: 'Puzzle',
    bgClass: 'game-icon-green',
    description: `Add a competitive edge to your campaigns with a picture puzzle challenge. Customers race to complete puzzles for a chance to win prizes, with a leaderboard to track speed and skill. Fully customizable to feature your brand's images.`
  },
  {
    icon: '/images/chest.svg',
    title: 'Treasure Chest',
    bgClass: 'game-icon-blue',
    description: `Treasure Chest adds excitement and mystery to your campaigns. Let your customers unlock a chest to reveal surprise rewards—whether it is discounts, free products, or instant rewards like Data or Airtime. Fully customizable, you can tailor the prizes to fit your brand’s offerings, making each unlock an unforgettable experience for your customers.`
  }
];

const steps = [
  {
    number: 'Ⅰ',
    title: 'Step 1',
    text: 'Embed our gamification script on your Website, Micro site or campaign landing page. (Minimal technical effort required)'
  },
  {
    number: 'Ⅱ',
    title: 'Step 2',
    text: 'Drive your customers to your website to play the games—via social media or Scan Product QR.'
  },
  {
    number: 'Ⅲ',
    title: 'Step 3',
    text: 'View & Reward Winners with our analytics dashboard.'
  }
];

export default function GamifyEngagementPage() {
  return (
    <main className="gamify-page">
      {/* Hero */}
      <section className="hero">
        <h1>Gamify Engagement</h1>
        <p>We believe in the power of play to drive deeper customer engagement.</p>
      </section>

      {/* Intro */}
      <section className="intro">
        <div className="intro-container">
          <div className="intro-image">
            <img src="/images/gamify.jpg" alt="Floating die" />
          </div>
          <div className="intro-text">
            <h2>
              We created gamification solutions designed to boost brand engagement and create fun and exciting digital experiences
            </h2>
            <p>
              With a portfolio of 4 ready to customize mobile games, complete with leaderboard to enhance competition &amp; Real Time Rewards mechanics, we provide a fun, competitive environment for you to drive brand engagement.
            </p>
          
            <Link to="/contact-us" className="learn-more">
              Learn More →
            </Link>
          </div>
        </div>
      </section>

      {/* Games List */}
      <section className="games-list">
        <div className="games-container">
          {games.map((game, i) => (
            <div key={i} className="game-card-container">
              <div className={`game-icon-card ${game.bgClass}`}>
                <img src={game.icon} alt={`${game.title} icon`} />
              </div>
              <div className="game-info-card">
                <h3 className="game-title">{game.title}</h3>
                <p className="game-description">{game.description}</p>
                {/* <img
                  src="/assets/icons/external-link.svg"
                  alt="Open"
                  className="external-link"
                /> */}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps-container">
          {steps.map((step, i) => (
            <div key={i} className="step-card">
              <div className="step-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.text}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
